export const SEARCH_URL = process.env.REACT_APP_PARTS_SEARCH_URL;
export const WEAR_PARTS_URL = "https://shop.fecon.com/collections/mulching-teeth";